import React from "react";
import { Button, message } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { useDownloadCSVContext } from "@src/pages/intelligence-search-v2/context/download-csv-context";
import { ChartActionProps } from ".";

export const DownloadCSV: React.FC<ChartActionProps> = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const { status, error, download } = useDownloadCSVContext();
    const isDownloading = status.type === "processing";

    React.useEffect(() => {
        if (error) messageApi.error(error);
    }, [error]);

    return (
        <div>
            {contextHolder}
            <Button
                type="text"
                loading={isDownloading}
                onClick={download}
                disabled={isDownloading}
                className="w-full flex justify-start items-center"
            >
                <CloudDownloadOutlined className="pb-1 text-[16px]" />
                Export full data
            </Button>
        </div>
    );
};
